// app/frontend/components/ui/stepper/ThemedStepper.tsx
import { Stepper, StepperProps } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { COLORS } from '../../../src/constants/theme';

function BaseThemedStepper(props: StepperProps) {
  return (
    <Stepper
      size="xs"
      iconSize={24}
      styles={{
        root: {
          '--step-transition': 'all 0.4s ease',
        },
        step: {
          '&[data-completed] .mantine-Stepper-stepIcon': {
            background: `linear-gradient(135deg, ${COLORS.orange}, #f97316)`,
            transition: 'var(--step-transition)',
            boxShadow: '0 0 8px rgba(234,88,12,0.5)',
          },
          '&[data-progress] .mantine-Stepper-stepIcon': {
            background: COLORS.orange,
            transition: 'var(--step-transition)',
            boxShadow: '0 0 6px rgba(234,88,12,0.4)',
          },
        },
        separator: {
          background: 'rgba(255,255,255,0.1)',
          transition: 'var(--step-transition)',
          marginLeft: 0,
          marginRight: 0,
          height: 2,
          '&[data-active]': {
            background: `linear-gradient(90deg, ${COLORS.orange}, #f97316)`,
            boxShadow: '0 0 12px rgba(234,88,12,0.4)',
          },
          '&[data-completed]': {
            background: `linear-gradient(90deg, ${COLORS.orange}, #f97316)`,
          },
        },
        stepLabel: {
          color: '#f2f2f2',
          fontSize: '0.875rem',
        },
        stepDescription: {
          color: '#e2e2e2',
          fontSize: '0.75rem',
        },
        stepIcon: {
          width: '24px',
          height: '24px',
          minWidth: '24px',
          minHeight: '24px',
        },
      }}
      completedIcon={<IconCheck size={14} color="white" />}
      {...props}
    />
  );
}

BaseThemedStepper.Step = Stepper.Step;
BaseThemedStepper.Completed = Stepper.Completed;

export const ThemedStepper = BaseThemedStepper;
